import "./loader.css";
import { colorSwitcherThree } from "../../constants/styleConstant";

function GlobalLoader({ title = "" }) {
  return (
    <div
      className="global-loader-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={title || "Loading"}
    >
      {title && (
        <div
          className="global-loader-title"
          style={{ color: colorSwitcherThree }} // ✅ use app style constant
        >
          {title}
        </div>
      )}
      <div
        className="global-loader-spinner"
        style={{ borderTopColor: colorSwitcherThree }} // ✅ spinner accent color
      ></div>
    </div>
  );
}

export default GlobalLoader;
